<template>
  <Page class="editions-disclaimer">
    <h1>{{ $t('editionsDisclaimer.title') }}</h1>
    <template v-for="(paragraph, index) in $t('editionsDisclaimer.content').slice(0)">
      <p :key="`paragraph-${index}`" v-html="paragraph" />
    </template>
  </Page>
</template>

<script>
  import Page from '../components/Page.vue';

  export default {
    components: {
      Page,
    },
  };
</script>

<style lang="scss" scoped>
  @import '../variables';
  #app[data-locale="ar"] .page.editions-disclaimer {
    direction: rtl;
    font-family: $ar-font-family;
    font-size: $ar-default-font-size;
  }
</style>
